import { Box } from '@mui/material'
import { forwardRef } from 'react'
import styles from './index.module.scss'

/**
 * Scrollable transcript region (gap 24px; background inherits from parent).
 */
const ChatMessagesScrollRegion = forwardRef(function ChatMessagesScrollRegion(
  { children, className, ...rest },
  ref,
) {
  return (
    <Box
      ref={ref}
      component="div"
      className={[styles.scroll, className].filter(Boolean).join(' ')}
      role="log"
      aria-live="polite"
      aria-relevant="additions"
      {...rest}
    >
      {children}
    </Box>
  )
})

export default ChatMessagesScrollRegion
